/**
 * EAI login error response codes will be kept here.
 */

export const LOGIN_ERRORS = {
  accountLocked: '9040', // not sure the difference between this and password
  passwordLocked: '9046', // password locked should take to account recovery
  badCredentials: '9036' // not 100% sure this is correct.
};



// WEBPACK FOOTER //
// ./src/app/login/login-error-config.ts